module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av546-4c34e5713fa053f94df9924be710b5bd.jpg";